import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { commissionSplitsService } from "services";
import { uiActions } from "store";
import { CommissionSplit, ErrorResponse, ListResponseDto } from "types";

const useGetCommissionSplitsQuery = ({
	fetchData,
	agentId,
}: {
	fetchData: { page: number; sortBy: { [key: string]: any } };
	agentId: string;
}) => {
	const dispatch = useDispatch();
	const { page, sortBy } = fetchData;
	const queryResult = useQuery(
		["getCommissionSplits", page, sortBy],
		() =>
			commissionSplitsService.getCommissionSplitsBody({
				agentId,
				page,
				sortBy,
			}),
		{
			onSuccess: (data: ListResponseDto<CommissionSplit>) => data,
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetCommissionSplitsQuery;
